import { FC, useId } from "react";
import { createFormikFields } from "@components/forms/fields/createFormikFields";
import styles from "./MemberManagement.module.scss";
import { ConfigurePermissionsFields } from "./ConfigurePermissionsFields";
import { AddMemberFormSchema, TeamFormProps } from "./types";

const fields = createFormikFields<AddMemberFormSchema>();

export const AddTeamFields: FC<TeamFormProps> = ({
    actingUserRole,
    entities,
}) => {
    const emailsTitleId = useId();

    return (
        <>
            <section className={styles.emailSection}>
                <header className={styles.sectionHeader}>
                    <h6 id={emailsTitleId} className={styles.sectionTitle}>
                        Email addresses
                    </h6>
                </header>

                <fields.Emails
                    name="emails"
                    aria-labelledby={emailsTitleId}
                    placeholder="Emails, comma separated"
                />
            </section>

            <ConfigurePermissionsFields
                actingUserRole={actingUserRole}
                entities={entities}
            />
        </>
    );
};
